export const extractSchemaName = (input: string): string | null => {
  const match = input.match(/iglu:com\.heycar\/(\w+)\/jsonschema/);
  return match ? match[1] : null;
};
